import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { DEFAULT_MAPBOX_TOKEN } from "./utils";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_TOKEN || DEFAULT_MAPBOX_TOKEN;

function RouterRoot() {
  return (
    <Routes>
      <Route path="*" element={<App />}>
        <Route path="detail/:listingId" element={<></>} />
      </Route>
    </Routes>
  );
}

createRoot(document.getElementById("emlakjet-root")).render(
  <ErrorBoundary>
    <BrowserRouter>
      <RouterRoot />
    </BrowserRouter>
  </ErrorBoundary>
);

export { App };
export default App;
